export default {
  // Login
  "login.title": "Login",
  "login.register": "Register",
  "login.email": "Email",
  "login.password": "Password",
  "login.button": "Login",
  "login.powered_by": "Powered by",
  "register.button": "Register",
  "register.confirm_password": "Confirm Password",
  "register.passwords_not_match": "Passwords do not match",
  "login.forgot_password": "Forgot password?",
  "login.reset_password_title": "Reset Password",
  "login.reset_password_instructions": "Enter your email address and we'll send you a link to reset your password.",
  "login.reset_password_sent": "Password reset email sent! Check your inbox and follow the link to reset your password.",
  "login.send_reset_link": "Send Reset Link",
  "login.email_required": "Please enter your email address",

  // Registration
  "registration.welcome": "Welcome",
  "registration.no_tenant_access": "You don't have access to any company yet. Please create a new company or request access to an existing one.",
  "registration.create_new_tenant": "Create New Company",
  "registration.request_access": "Request Access to Existing Company",
  "registration.or": "or",
  "registration.logout": "Sign out and use different account",
  "registration.create_tenant_title": "Create New Company",
  "registration.create_tenant_description": "Create a new company to start using the application. You will be the administrator of this company.",
  "registration.company_name": "Company Name",
  "registration.company_name_placeholder": "Enter company name",
  "registration.company_name_required": "Company name is required",
  "registration.business_id": "Business ID",
  "registration.business_id_placeholder": "e.g. 1234567-8",
  "registration.business_id_required": "Business ID is required",
  "registration.create_tenant_button": "Create Company",
  "registration.tenant_created": "Company created successfully!",
  "registration.create_error": "Failed to create company. Please try again.",
  "registration.request_access_title": "Request Access",
  "registration.request_access_description": "Enter the company ID to request access. An administrator will review your request.",
  "registration.tenant_id": "Company ID",
  "registration.tenant_id_required": "Company ID is required",
  "registration.message_optional": "Message (optional)",
  "registration.message_placeholder": "Explain why you need access...",
  "registration.send_request": "Send Request",
  "registration.request_sent": "Access request sent successfully!",
  "registration.request_error": "Failed to send request. Please check the company ID and try again.",
  "registration.coa_type": "Chart of Accounts",
  "registration.coa_real_estate": "Real Estate (Kiinteistö)",
  "registration.coa_business": "Business (Yritys)",
  "registration.coa_association": "Association (Yhdistys)",
  "registration.terms_accept": "I accept the",
  "registration.terms_link": "Terms of Service",
  "registration.terms_required": "You must accept the terms of service to continue",

  // Company Info Setup
  "setup.title": "Complete Company Setup",
  "setup.description": "Please provide the required company information to continue.",
  "setup.company_info": "Company Information",
  "setup.company_name": "Company Name",
  "setup.address": "Address",
  "setup.bank_info": "Bank Account",
  "setup.email": "Company Email",
  "setup.street_address": "Street Address",
  "setup.zip_code": "Postal Code",
  "setup.city": "City",
  "setup.country": "Country",
  "setup.currency": "Currency",
  "setup.iban": "IBAN",
  "setup.bic": "BIC/SWIFT",
  "setup.bank_name": "Bank Name",
  "setup.submit": "Complete Setup",
  "setup.required": "This field is required",
  "setup.success": "Company setup completed successfully!",
  "setup.error": "Failed to save company information. Please try again.",
};
